<avd-page-title
    title="Getting started"
    imgSrc="./assets/images/Component-Getting-Started-128x82-v2d.png"
></avd-page-title>

<p>
    Follow this step-by-step guide to start developing with the UILab Angular
    Components ({{ packageName }}).
</p>

<h2>Step 1: Update Angular</h2>
<p>UILab Angular supports Angular 20, and 21.</p>
<p>
    See Angular’s guide on how to upgrade Angular from your current version to
    the target version.
</p>

<h2>Step 2: Connect to feed</h2>
<p>
    Follow the Azure instructions to add a .npmrc file that enables access to
    our private artifact registry.
</p>
<p>
    When prompted to choose how to connect to the feed, select npm to view the
    step-by-step setup guide.
</p>

<h2>Step 3: Install the library</h2>
<p>
    You can install the UILab Angular Components ({{ packageName }}) library
    using the npm package manager.
</p>
<pre><code [highlight]="installCommand" [language]="'bash'"></code></pre>

<h2>Step 4: Set up the application</h2>

<h3>Step 4a: Import UILab Angular Components styles</h3>
<p>
    Import the UILab Components styles library and theme in your angular JSON or
    equivalent file. To learn more, visit Theming, and for more about UILab
    theming styles, visit Getting started for Styles (CSS).
</p>
<pre><code [highlight]="stylesSnippet" [language]="'json'"></code></pre>

<h3>Step 4b: Import the UILab Angular component library</h3>
<p> Import our library into your standalone component or NgModule. </p>

<uilab-mat-tab-group animationDuration="0ms">
    <uilab-mat-tab label="Standalone">
        <pre><code [highlight]="importTabs[0].code" [language]="'typescript'"></code
    ></pre>
    </uilab-mat-tab>
    <uilab-mat-tab label="NgModule">
        <pre><code [highlight]="importTabs[1].code" [language]="'typescript'"></code></pre>
    </uilab-mat-tab>
</uilab-mat-tab-group>

<h2>Step 5: Add icons</h2>
<p>UILab Angular components can be used with UILab UX icons.</p>
<p>
    This documentation and the component examples use the UILab UX icons
    library. Follow this
    <a [routerLink]="['/build/components/getting-started/iconography']">
        getting started guide
    </a>
    to learn how to add icons to your project. They can be imported into your
    standalone component file, or your NgModule.
</p>

<h2>Step 6: Use the components</h2>
<p>
    After adding UILab UX icons, you’re ready to use UILab Angular components by
    copying and pasting the example code into your application.
</p>
<p>
    Check out <a [routerLink]="['/build/components/button/code']">Button</a> to
    give it a try.
</p>
